import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MenuDTO } from '../models/menu-dto';
import { Select2Data } from 'ng-select2-component';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class SharedService {

  private pathAPI = environment.urlAPI;
  private controller = "Shared/";
  menus: any[] = [];

  constructor(private http: HttpClient) { }

  public getMenu(): Observable<MenuDTO> {
    return this.http.get<MenuDTO>(this.pathAPI + this.controller + 'GetMenu');
  }

  public GetRoles(): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'GetRoles');
  }


  public GetDistributors(): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'GetDistributors');
  }

  public GetUserDistributors(): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'GetUserDistributors');
  }

  public getLeapmotorFilters(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetLeapmotorFilters');
  }

  public getRrss(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetRrss');
  }

  public GetMonths(): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'GetMonths');
  }




}
